import { Space } from 'antd';
import { reverse, sortBy } from 'lodash';
import moment from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { PastProjectStatus } from 'api/project';
import { StatusUpdateStatuses } from 'api/status-updates';
import { Avatar } from 'components/atoms/avatar';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { ListWithLink } from 'components/atoms/list-with-links';
import { Tag } from 'components/atoms/tag';
import { getStatusData } from 'components/organisms/projects/project-list/constants';
import { Label01, Text02 } from 'components/styles';
import { fullName } from 'utils/full-name';
import { getProjectStatusUpdatesDetailUrl } from 'utils/urls';

const Date = styled.span`
  ${Label01};
  ${Text02};
`;

export const DataContent: FC<{
  data?: PastProjectStatus[];
  projectId: number;
}> = ({ data, projectId }) => {
  return (
    <ListWithLink
      dataSource={reverse(sortBy(data, 'updatedAt'))}
      renderItem={(item) => {
        const currentStatus = getStatusData(
          StatusUpdateStatuses,
          item.projectStatusName,
        );

        return (
          <ListWithLink.Item>
            <a
              href={getProjectStatusUpdatesDetailUrl(
                projectId,
                item.projectStatusId,
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Space>
                <Date>
                  {item.updatedAt && (
                    <HumanisedDate timestamp={moment(item.updatedAt)} />
                  )}
                </Date>
                <Avatar
                  name={fullName(item.updatedBy)}
                  src={item.updatedBy.photoUrl}
                />
                <Tag color={currentStatus?.color}>{currentStatus?.label}</Tag>
              </Space>
            </a>
          </ListWithLink.Item>
        );
      }}
    />
  );
};
